import css from '../../liftPage.module.css'
import FormField from '../../../../../../shared/Forms/FormField'
import timeUtils from '../../../../../../utils/time.utils.ts'
import { IEquipment } from '../../../../equipment.types.ts'
import LiftMileageStatisticsCard from '../Statistics/LiftMileageStatiscticsCard'
import TextWithCopy from '../../../../../../shared/Text/TextWithCopy'
import SeparateLine from '@/shared/Forms/SeparateLine'
import LiftModeCard from '@/pages/Equipment/pages/LiftPage/components/Statistics/LiftModeCard'
import LiftDoorOpenTimeStatisticsCard from '@/pages/Equipment/pages/LiftPage/components/Statistics/LiftDoorOpenCard'
import LiftFloorsCountCard from '@/pages/Equipment/pages/LiftPage/components/Statistics/LiftFloorsCountCard'
import LiftTotalRidesStatisticCard from '@/pages/Equipment/pages/LiftPage/components/Statistics/LiftTotalRidesStatiscticCard'
import EquipmentOrganizationsText from '@/pages/Equipment/components/Common/EquipmentOrganizationsText'
import LiftPagePassportContent from '@/pages/Equipment/pages/LiftPage/components/LiftPagePassportContent/index.tsx'
import EquipmentPassportActionsMenu from '@/pages/Equipment/components/Passport/EquipmentPassportActionsMenu/index.tsx'
import PassportLastUpdatedLabel from '@/pages/Equipment/components/Passport/PassportLastUpdatedLabel/index.tsx'
import PassportVersionHistoryButton from '@/pages/Equipment/components/Passport/PassportVersionHistoryButton/index.tsx'
import useIsAdmin from '@/pages/User/hooks/useIsAdmin.ts'
import formatUtils from '@/utils/format.utils.ts'
import LkdsModeCard from '@/pages/Equipment/pages/LiftPage/components/Statistics/LkdsModeCard'
import LkdsMetricCard from '@/pages/Equipment/pages/LiftPage/components/Statistics/LkdsMetricCard'

interface IProps {
  equipment: IEquipment
}

const AboutLiftCardContent = (props: IProps) => {
  const isAdmin = useIsAdmin()
  const isLkdsProtocol = props.equipment.protocolId === 'lkds'

  return (
    <div className={css.mainCardContent} style={{ position: 'relative' }}>
      <div className={css.descriptionGrid} data-protocol={props.equipment.protocolId}>
        <FormField label="Дата создания" type="description">
          {timeUtils.formatDate(props.equipment.createdAt, 'dd.MM.yyyy')}
        </FormField>
        {props.equipment.protocolId === 'lp-lift' && (
          <FormField label="ID контроллера" type="description">
            <TextWithCopy text={props.equipment.connectionConfiguration.controllerId}>
              <span className="line-clamp" title={props.equipment.connectionConfiguration.controllerId}>
                {props.equipment.connectionConfiguration.controllerId}
              </span>
            </TextWithCopy>
          </FormField>
        )}
        {isAdmin && (
          <FormField label="Организация" type="description">
            <EquipmentOrganizationsText organizations={props.equipment.organizations} />
          </FormField>
        )}
        <FormField label="Комментарий" type="description">
          {props.equipment.description || '-'}
        </FormField>
      </div>

      <SeparateLine />
      <div className="flex-lines gap16">
        <h4 className="text-heading-4">Метрики</h4>
        <div className="flex-wrap gap16">
          {isLkdsProtocol ? (
            <>
              <div style={{ width: '194px' }}>
                <LkdsModeCard title="Режим работы" equipmentId={props.equipment.id} />
              </div>
              <div style={{ width: '194px' }}>
                <LkdsMetricCard
                  title="Всего остановок"
                  equipmentId={props.equipment.id}
                  sourceId="stopsNumberTotal"
                  format={(value) => formatUtils.formatNumber(value)}
                />
              </div>
              <div style={{ width: '194px' }}>
                <LkdsMetricCard
                  title="Счетчик рестартов"
                  equipmentId={props.equipment.id}
                  sourceId="restartCounter"
                  format={(value) => formatUtils.formatNumber(value)}
                />
              </div>
              <div style={{ width: '194px' }}>
                <LkdsMetricCard
                  title="Время работы ПД"
                  equipmentId={props.equipment.id}
                  sourceId="doorsDriveWorkTimeSeconds"
                  format={(value) => `${(value / 3600).toLocaleString('ru-RU', { maximumFractionDigits: 2 })} ч.`}
                />
              </div>

              <div style={{ width: '194px' }}>
                <LkdsMetricCard
                  title="Время работы ГП"
                  equipmentId={props.equipment.id}
                  sourceId="mainDriveWorkTimeSeconds"
                  format={(value) => `${(value / 3600).toLocaleString('ru-RU', { maximumFractionDigits: 2 })} ч.`}
                />
              </div>
            </>
          ) : (
            <>
              <div style={{ width: '194px' }}>
                <LiftModeCard title="Станция" equipmentId={props.equipment.id} />
              </div>
              <div style={{ width: '194px' }}>
                <LiftFloorsCountCard title="Кол-во этажей" equipmentId={props.equipment.id} />
              </div>
              <div style={{ width: '194px' }}>
                <LiftMileageStatisticsCard title="Пробег кабины" equipmentId={props.equipment.id} />
              </div>
              <div style={{ width: '194px' }}>
                <LiftTotalRidesStatisticCard equipmentId={props.equipment.id} />
              </div>
              <div style={{ width: '194px' }}>
                <LiftDoorOpenTimeStatisticsCard title="Открытие дверей" equipmentId={props.equipment.id} />
              </div>
            </>
          )}
        </div>
      </div>
      <SeparateLine />
      <div className="flex-lines gap16">
        <div className="flex-space-between">
          <h4 className="text-heading-4" style={{ marginBottom: 'auto' }}>
            Паспорт лифта
          </h4>
          <div className="inline-flex-gap gap8 center">
            <PassportLastUpdatedLabel equipment={props.equipment} />
            <PassportVersionHistoryButton equipment={props.equipment} />
            <EquipmentPassportActionsMenu equipment={props.equipment} />
          </div>
        </div>
        <LiftPagePassportContent equipmentId={props.equipment.id} />
      </div>
    </div>
  )
}

export default AboutLiftCardContent
